
import {
    GLOBALS_SELECTED_SEDE_SET,
} from './types';

const globalSedeSetActionCreator = (sede) => ({
    type: GLOBALS_SELECTED_SEDE_SET,
    sede,
});
export const globalSedeSetAction = (sede) => (dispatch) => dispatch(globalSedeSetActionCreator(sede));
